export default {
  OPEN_ACCOUNT_INVOICE_QUICK_VIEW(state, accountInvoiceId) {
    state.accountInvoiceQuickViewId = accountInvoiceId
  },

  CLOSE_ACCOUNT_INVOICE_QUICK_VIEW(state) {
    state.accountInvoiceQuickViewId = null
  }
}
